import { render } from "./HeaderPage.vue?vue&type=template&id=50f59972"
import script from "./HeaderPage.vue?vue&type=script&lang=js"
export * from "./HeaderPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/test/Documents/GitHub/LpMooveTrainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__